export const ALTI_CODING_API_ENDPOINT =
  'altimetrie/1.0/calcul/alti/rest/elevation.json';

export const GEO_CODING_REVERSE_API_ENDPOINT = 'geocodage/reverse';

export const GEO_CODING_SEARCH_API_ENDPOINT = 'geocodage/search';

export const NAVIGATION_ITINERARY_API_ENDPOINT = 'navigation/itineraire';
